"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
class FetchMoreWidget extends fmko_ts_common_1.Widget {
    constructor(scrollContainer) {
        super();
        this.scrollContainer = scrollContainer;
        this.check = () => {
            this.checkIfVisible();
        };
        this.element = document.createElement("div");
    }
    arm(cb) {
        this.cb = cb;
        if (this.scrollContainer) {
            this.scrollContainer.addEventListener("scroll", this.check);
            this.scrollContainer.addEventListener("resize", this.check);
        }
        else {
            window.addEventListener("scroll", this.check);
            window.addEventListener("resize", this.check);
        }
        if (this.element.parentElement && this.element.parentElement.parentElement) {
            this.element.parentElement.parentElement.classList.remove("hidden");
        }
        // Marker may already be visible!
        this.check();
    }
    disarm() {
        this.cb = null;
        if (this.scrollContainer) {
            this.scrollContainer.removeEventListener("scroll", this.check);
            this.scrollContainer.removeEventListener("resize", this.check);
        }
        else {
            window.removeEventListener("scroll", this.check);
            window.removeEventListener("resize", this.check);
        }
    }
    hide() {
        if (this.element.parentElement && this.element.parentElement.parentElement) {
            this.element.parentElement.parentElement.classList.add("hidden");
        }
    }
    checkIfVisible() {
        if (this.cb && this.isScrolledIntoView(this.element)) {
            this.cb();
            this.disarm();
        }
    }
    isScrolledIntoView(el) {
        let elemTop = el.getBoundingClientRect().top;
        let elemBottom = el.getBoundingClientRect().bottom;
        let inView = (elemTop >= 0) && (elemBottom <= document.documentElement.clientHeight);
        const isVisible = el.offsetParent !== null;
        return inView && isVisible;
    }
}
exports.default = FetchMoreWidget;
//# sourceMappingURL=FetchMoreWidget.js.map